// Mock data for astrology website

export const astrologerInfo = {
  name: "Master Shrivatsa",
  title: "Renowned Vedic Astrologer & Spiritual Healer",
  phone: "+91 9845469597",
  email: "mastershrivatsa@gmail.com",
  address: "Serving Clients Worldwide - USA, Canada, UK, Australia & Beyond",
  experience: "25+ Years",
  description: "Master Shrivatsa is a world-renowned Vedic astrologer and spiritual healer with over 25 years of experience helping clients across the USA and worldwide. Specializing in ancient Indian astrology, palmistry, tarot reading, and spiritual guidance, he has transformed thousands of lives with accurate predictions and powerful remedies.",
  seoDescription: "Consult Master Shrivatsa - America's most trusted Vedic astrologer for love problems, career guidance, health issues, marriage compatibility, black magic removal, and spiritual healing. Serving USA, Canada & worldwide. Get accurate predictions and effective remedies.",
  expertise: [
    "Vedic Astrology & Horoscope Reading",
    "Palmistry & Numerology",
    "Tarot Card Reading",
    "Vastu Shastra Consultation",
    "Spiritual Healing & Meditation",
    "Black Magic Removal",
    "Love & Relationship Counseling",
    "Career & Business Astrology"
  ]
};

export const services = [
  {
    id: 1,
    title: "Love Back",
    description: "Desperate to get your ex back? Don't lose hope. Get immediate, confidential guidance 24/7 to reunite with your lost love.",
    icon: "Heart",
    image: "https://images.unsplash.com/photo-1518495973542-4542c06a5843"
  },
  {
    id: 2,
    title: "Palm Reading",
    description: "Worried about your future? Discover what fate has in store. Get instant answers about love, career, and destiny.",
    icon: "Hand",
    image: "https://images.unsplash.com/photo-1533294455009-a77b7557d2d1"
  },
  {
    id: 3,
    title: "Kundali Reading",
    description: "Feeling lost and confused? Your birth chart holds the answers. Get immediate clarity about your life path now.",
    icon: "Book",
    image: "https://images.unsplash.com/photo-1729335511883-29eade10006b"
  },
  {
    id: 4,
    title: "Horoscope Reading",
    description: "Need urgent guidance? Discover what the stars reveal about your immediate future. Get answers NOW - 24/7 available.",
    icon: "Stars",
    image: "https://images.unsplash.com/photo-1515942661900-94b3d1972591"
  },
  {
    id: 5,
    title: "Tarot Card Reading",
    description: "Facing a critical decision? The cards never lie. Get immediate insight into your past, present, and future.",
    icon: "Sparkles",
    image: "https://images.unsplash.com/photo-1464802686167-b939a6910659"
  },
  {
    id: 6,
    title: "Match Making",
    description: "Worried if they're the one? Stop guessing. Get instant compatibility analysis before you make a life-changing decision.",
    icon: "HeartHandshake",
    image: "https://images.unsplash.com/photo-1623172959921-630212f71058"
  },
  {
    id: 7,
    title: "Family Disputes",
    description: "Family falling apart? Don't let it break you. Get immediate help to restore peace and harmony at home.",
    icon: "Users",
    image: "https://images.unsplash.com/photo-1573689705959-7786e029b31e"
  },
  {
    id: 8,
    title: "Black Magic Removal",
    description: "Feeling cursed or under attack? Don't suffer in silence. Get immediate protection from negative energies and evil forces.",
    icon: "Shield",
    image: "https://images.unsplash.com/photo-1462331940025-496dfbfc7564"
  },
  {
    id: 9,
    title: "Spiritual Healer",
    description: "Soul feeling broken? Lost all hope? Get immediate spiritual healing and find inner peace. Help is available NOW.",
    icon: "Flame",
    image: "https://images.unsplash.com/photo-1465101162946-4377e57745c3"
  },
  {
    id: 10,
    title: "Health Problem",
    description: "Mysterious illness won't go away? Get spiritual insights into health issues. Immediate guidance available 24/7.",
    icon: "Heart",
    image: "https://images.pexels.com/photos/1376766/nature-milky-way-galaxy-space-1376766.jpeg"
  },
  {
    id: 11,
    title: "Court Case",
    description: "Facing legal trouble? Terrified of losing everything? Get urgent astrological guidance for favorable outcomes.",
    icon: "Scale",
    image: "https://images.pexels.com/photos/2832071/pexels-photo-2832071.jpeg"
  },
  {
    id: 12,
    title: "Vastu Consultation",
    description: "Nothing going right at home? Your space might be the problem. Get immediate Vastu solutions for peace and prosperity.",
    icon: "Home",
    image: "https://images.unsplash.com/photo-1444703686981-a3abbc4d4fe3"
  },
  {
    id: 13,
    title: "Evil Eye Removal",
    description: "Feel like someone cursed you? Bad luck following you everywhere? Get immediate protection and remove negative energy.",
    icon: "Eye",
    image: "https://images.unsplash.com/photo-1499209974431-9dddcece7f88"
  },
  {
    id: 14,
    title: "Love Marriage",
    description: "Parents against your relationship? Don't give up on love. Get urgent help to convince family and secure your happiness.",
    icon: "HeartHandshake",
    image: "https://images.pexels.com/photos/34768710/pexels-photo-34768710.jpeg"
  },
  {
    id: 15,
    title: "Hanuman Pooja",
    description: "Need divine intervention urgently? Hanuman Pooja brings strength and protection. Get immediate spiritual support NOW.",
    icon: "Flame",
    image: "https://images.pexels.com/photos/33016137/pexels-photo-33016137.jpeg"
  },
  {
    id: 16,
    title: "Kaali Pooja",
    description: "Facing powerful enemies? Need protection from dark forces? Get immediate help through powerful Kaali Pooja rituals.",
    icon: "Sparkles",
    image: "https://images.unsplash.com/photo-1518495973542-4542c06a5843"
  },
  {
    id: 17,
    title: "Vashikaran Pooja",
    description: "Lost control of your life? Need someone to listen? Get immediate help through traditional Vashikaran guidance.",
    icon: "Sparkles",
    image: "https://images.unsplash.com/photo-1533294455009-a77b7557d2d1"
  },
  {
    id: 18,
    title: "Lakshmi Pooja",
    description: "Drowning in financial problems? Prosperity seems impossible? Get immediate help to attract wealth and abundance.",
    icon: "Sparkles",
    image: "https://images.unsplash.com/photo-1729335511883-29eade10006b"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marcus Johnson",
    location: "New York, USA",
    rating: 5,
    text: "Master Shrivatsa completely changed my life! His accurate predictions and powerful remedies helped me overcome my career obstacles. I was stuck in a dead-end job, and within 3 months of following his guidance, I got promoted. Highly recommended!",
    image: null
  },
  {
    id: 2,
    name: "Keisha Williams",
    location: "Los Angeles, USA",
    rating: 5,
    text: "I was struggling with relationship issues and felt lost. Master Shrivatsa's guidance was transformative. His love problem solutions and remedies worked like magic! My relationship is now stronger than ever. Thank you so much!",
    image: null
  },
  {
    id: 3,
    name: "David Miller",
    location: "Chicago, USA",
    rating: 5,
    text: "Incredible experience! The kundali reading was so accurate. Master Shrivatsa identified issues I never shared and provided solutions that actually worked. His spiritual guidance helped me find peace and direction in life.",
    image: null
  },
  {
    id: 4,
    name: "Jasmine Brown",
    location: "Houston, USA",
    rating: 5,
    text: "The palm reading session was eye-opening. Every prediction was spot on! Master Shrivatsa's expertise in Vedic astrology is unmatched. I consulted him for marriage compatibility, and his advice saved my relationship. Grateful beyond words!",
    image: null
  },
  {
    id: 5,
    name: "Robert Davis",
    location: "Miami, USA",
    rating: 5,
    text: "I was facing severe business losses and legal issues. Master Shrivatsa's astrological remedies and court case solutions helped me win my case and turn my business around. His guidance is worth every penny!",
    image: null
  },
  {
    id: 6,
    name: "Aaliyah Martinez",
    location: "Phoenix, USA",
    rating: 5,
    text: "Master Shrivatsa removed black magic effects that were ruining my family's peace. His powerful spiritual healing and remedies brought happiness back to our home. We're forever grateful for his help!",
    image: null
  }
];

export const statistics = [
  { label: "Years Experience", value: "25+", icon: "Award", context: null },
  { label: "Happy Clients", value: "10000+", icon: "Users", context: "across USA & worldwide" },
  { label: "Client Satisfaction", value: "98%", icon: "TrendingUp", context: "based on follow-up surveys" },
  { label: "Services Offered", value: "18+", icon: "Sparkles", context: null }
];

export const heroSlides = [
  {
    id: 1,
    title: "Astrology & Palm Reading",
    subtitle: "Expert Palm Reading and Psychic Reading Fortune Telling Services Across USA",
    image: "https://images.unsplash.com/photo-1444703686981-a3abbc4d4fe3"
  },
  {
    id: 2,
    title: "Love Back Solutions",
    subtitle: "Reunite with your lost love. Expert astrological guidance available 24/7",
    image: "https://images.unsplash.com/photo-1464802686167-b939a6910659"
  },
  {
    id: 3,
    title: "Black Magic Removal",
    subtitle: "Protect yourself from negative energies. Get immediate expert spiritual healing",
    image: "https://images.unsplash.com/photo-1465101162946-4377e57745c3"
  }
];
